import { takeLatest, call, put } from 'redux-saga/effects';
import buddyReferralActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';

const {
  Types: { LOAD_BUDDY_REFERRAL_REQUEST },
  Creators: { loadBuddyReferralSuccess, loadBuddyReferralFailure },
} = buddyReferralActions;

const {
  Creators: { setError },
} = errorActions;

function* loadBuddyReferral({ caId }) {
  try {
    const { data } = yield call(dxApi.get, `/api/profile/buddy-data-profile`, {
      params: {
        caid: caId,
        isPotal: true,
      },
    });
    if (!data.success) {
      yield put(loadBuddyReferralFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadBuddyReferralSuccess(data.data));
    }
  } catch (error) {
    yield put(loadBuddyReferralFailure(error));
    yield put(setError('Load primary card error.'));
  }
}

export function* buddyReferralSaga() {
  yield takeLatest(LOAD_BUDDY_REFERRAL_REQUEST, loadBuddyReferral);
}
